import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { filter, map, take, tap } from 'rxjs/operators';

import { notNullOrUndefined } from '../../../common/utils/not-null-or-undefined';
import { DataService } from '../../../core/providers/data/data.service';
import { ServerResponseService } from '../../../core/providers/server-response/server-response.service';
import {
    GetProductVariantDetailDocument,
    GetProductVariantDetailQuery,
    SortOrder,
} from '../../common/gql/graphql';

export const variantDetailResolver: ResolveFn<GetProductVariantDetailQuery['productVariant']> = (route) => {
    const serverResponseService = inject(ServerResponseService);

    return inject(DataService)
        .query(
            GetProductVariantDetailDocument,
            {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                sku: route.paramMap.get('sku')!,
                reviewOptions: {
                    take: 3,
                    sort: {
                        upvotes: SortOrder.DESC,
                    },
                },
            },
            { ssr: true },
        )
        .pipe(
            map((data) => data.productVariant),
            filter(notNullOrUndefined),
            take(1),
            tap((productVariant) => {
                if (productVariant.siblings <= 0) {
                    const redirectUrl = `/p/${productVariant.product.slug}`;
                    serverResponseService.redirect(redirectUrl);
                }
            }),
        );
};
